export default "/_next/static/images/97e053ca5a58c0ca52853eb8eccf4b96.jpg";